import $ from 'jquery';
import Templates from './Templates/Index.js';
import { handleValidateImageUpload } from './Utils/ValidateImageUpload.js';
import { handleValidateFileUpload } from './Utils/ValidateFileUpload.js';
import { EventBus } from 'utils/event-bus';

const handleChangePrompt = (editor, prompt_template) => {
  const confirmed = confirm('Are you sure? This will overwrite your prompt');
  if (!confirmed) return; 
  EventBus.$emit('handleChangeTemplateEditor', prompt_template);
  editor.setContent('');
  editor.insertContent(prompt_template);
  editor.getBody().firstChild.scrollIntoView();
};

export const EditorOptionsWritten = {
    selector: 'text-editor-written',
    menubar: false,
    branding: false,
    resize: false,
    elementpath: false,
    placeholder: '',
    toolbar_items_size: 'small',
    browser_spellcheck: true,
    content_css: '/static/tinymce/tinymce.css',
    content_style: '/static/tinymce/Content_Style.css',
    emoticons_append: {
      custom_mind_explode: {
        keywords: ['brain', 'mind', 'explode', 'blown'],
        char: '🤯',
      },
    },
    plugins: [
      'link, media, autolink, advlist, lists, lists code emoticons,fullscreen, table, wordcount, nonbreaking',
    ],
    nonbreaking_force_tab: true,
    noneditable_noneditable_class: 'mceNonEditable',
    block_formats: 'Body=p;Header 1=h2;Header 2=h3;',
    toolbar:
      'fullscreen | undo redo | bold underline | alignleft aligncenter | removeformat | numlist bullist | formatselect | emoticons link imageupload fileupload media | table | templates',
    skin_url: '/static/tinymce/tiny5skin/skins/ui/tiny5skin',
    media_alt_source: false,
    media_poster: false,
    media_dimensions: false,
    link_title: false,
    default_link_target: '_blank',
    target_list: false,
    contextmenu: false,
    toolbar_drawer: false,
    toolbar_mode: 'sliding',
    statusbar: true,
    setup: function (editor) {
      const imageUploader = $(
        '<input id="tinymce-uploader" type="file" name="pic" accept="image/*" style="display:none">'
      );
      const fileUploader = $(
        '<input id="tinymce-uploader-2" type="file" name="file" accept=".pdf, .xls, .xlsx, .doc, .docx, .txt, .ppt, .pptx" style="display:none">'
      );
      $(editor.getElement()).parent().append(imageUploader);
      $(editor.getElement()).parent().append(fileUploader);
      imageUploader.on('change', () => {
        const input = imageUploader.get(0);
        const files = input.files;
        handleValidateImageUpload(files, editor, imageUploader);
      });
      fileUploader.on('change', () => {
        const input = fileUploader.get(0);
        const files = input.files;
        handleValidateFileUpload(files, editor, fileUploader);
      });
      editor.ui.registry.addButton('imageupload', {
        icon: 'image',
        tooltip: 'Insert/edit image',
        onAction: () => imageUploader.trigger('click'),
      });
      editor.ui.registry.addButton('fileupload', {
        icon: 'upload',
        tooltip: 'Insert/edit file',
        onAction: () => fileUploader.trigger('click'),
      });
      editor.ui.registry.addMenuButton('templates', {
        icon: 'paste-text',
        text: 'Templates',
        fetch: (callback) => {
          const items = [];
          Templates.forEach((el, index) => {
            items.push({ text: `${index + 1} - ${el.title}`, type: 'menuitem', onAction: () => handleChangePrompt(editor, el.prompt) });
          });
          callback(items);
        },
      });
    },
  };

  export const EditorOptionsVerbal = {
    selector: '#text-editor-written',
    menubar: false,
    branding: false,
    resize: false,
    elementpath: false,
    placeholder: '',
    toolbar_items_size: 'small',
    browser_spellcheck: true,
    content_css: '/static/tinymce/tinymce.css',
    emoticons_append: {
      custom_mind_explode: {
        keywords: ['brain', 'mind', 'explode', 'blown'],
        char: '🤯',
      },
    },
    plugins: [
      'link, media, autolink, advlist, lists, paste, noneditable, lists code emoticons,fullscreen, table, wordcount, nonbreaking',
    ],
    nonbreaking_force_tab: true,
    noneditable_noneditable_class: 'mceNonEditable',
    block_formats: 'Body=p;Header 1=h2;Header 2=h3;',
    toolbar:
      'fullscreen | undo redo | bold italic underline | alignleft aligncenter | removeformat | numlist bullist | emoticons',
    skin_url: '/static/tinymce/tiny5skin/skins/ui/tiny5skin',
    media_alt_source: false,
    media_poster: false,
    media_dimensions: false,
    link_title: false,
    default_link_target: '_blank',
    target_list: false,
    contextmenu: false,
    toolbar_drawer: false,
    toolbar_mode: 'sliding',
    statusbar: false,
    toolbar_location: 'bottom'
  };


// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/EditorMCE/EditorConfig.js